module.exports = __webpack_public_path__ + "img/star.4772b9a3.svg";